export default __webpack_public_path__ + "static/media/poster-mariana.936d5b56.jpg";